import { indigo, pink } from '@mui/material/colors'

export default {
    palette: {
        mode: 'light',
        primary: {
            light: indigo[300],
            main: indigo[500],
            dark: indigo[700],
        },
        secondary: {
            light: pink.A200,
            main: pink.A400,
            dark: pink.A700,
        },
    },
}
